<template>
	<button
		:value="modelValue"
		:aria-checked="modelValue ? 'true' : null"
		:disabled="disabled"
		:class="{enabled: modelValue, animate: animateChange}"
		class="base-switch"
		role="switch"
		tabindex="0"
		type="button"
		@click="onClick"
	>
		<span v-if="screenReaderLabel" class="sr-only">{screenReaderLabel}</span>
		<span aria-hidden="true" class="knob" />
	</button>
</template>

<script>
export default {
	name: 'BaseSwitch',
	props: {
		modelValue: Boolean,
		disabled: Boolean,
		screenReaderLabel: String,
	},
	emits: ['update:modelValue'],
	data() {
		return {
			animateChange: false,
		}
	},
	methods: {
		onClick() {
			// only animate after the first user triggered change
			this.animateChange = true
			this.$emit('update:modelValue', !this.modelValue)
		},
	},
}
</script>

<style scoped>
.base-switch {
	width: 24px;
	height: 14px;
	border-radius: 7px;
	position: relative;
	display: inline-flex;
	flex-shrink: 0;
	border-width: 2px;
	border-color: transparent;
	margin-top: 1px;
}

.base-switch .knob {
	height: 10px;
	width: 10px;
	border-radius: 100%;
	pointer-events: none;
	display: inline-block;
}

.base-switch:focus-visible {
	outline: none;
	box-shadow:
		var(--blue-500) 0px 0px 0px 0px,
		rgba(var(--blue-500), 0.75) 0px 0px 0px 1px,
		rgba(0, 0, 0, 0) 0px 0px 0px 0px;
}

.base-switch:focus {
	outline-offset: 1px;
}

/* eslint-disable-next-line vue-scoped-css/no-unused-selector */
.base-switch-small {
	width: 16px;
	height: 10px;
	border-radius: 5px;
}

.base-switch-small .knob {
	height: 6px;
	width: 6px;
}

/* COLORS */
.base-switch {
	background-color: var(--gray-400);
}

.base-switch .knob {
	background-color: #fff;
}

.dark .base-switch:not(.enabled) {
	background-color: var(--gray-600);
}

.dark .base-switch:not(.enabled) .knob {
	background-color: var(--gray-800);
}

.base-switch-gray .knob {
	background-color: var(--gray-100) !important;
}

/* eslint-disable-next-line vue-scoped-css/no-unused-selector */
.base-switch-gray:not(.enabled) {
	background-color: var(--gray-400) !important;
}

.enabled {
	background-color: var(--green-500);
}

.enabled.yellow {
	background-color: var(--yellow-500);
}

.base-switch.enabled .knob {
	background-color: #fff;
	transform: translateX(100%);
}

.dark button:disabled {
	cursor: not-allowed;
	background-color: var(--gray-400);
}

button:disabled {
	cursor: not-allowed;
	background-color: var(--gray-500);
}

.animate {
	--transitionTimingFunction: ease-in-out;
	--transitionDuration: 0.2s;

	transition-timing-function: var(--transitionTimingFunction);
	transition-duration: var(--transitionDuration);
	transition: background-color;
}

.animate .knob {
	transition-timing-function: var(--transitionTimingFunction);
	transition-duration: var(--transitionDuration);
	transition-property: transform;
}
</style>
